<template>
  <div class="app-inner">
    <el-form :inline="true">
      <el-form-item label="审核状态">
        <el-select v-model="type" clearable>
          <el-option
          v-for="item in typeList"
          :key="item.value"
          :label="item.label"
          :value="item.value"/>
        </el-select>
      </el-form-item>
      <el-form-item label="编号">
        <el-input v-model="eventId" clearable placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="用章原因">
        <el-input v-model="applyReason" clearable placeholder="请输入"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="query">查询</el-button>
        <el-button type="primary" @click="applicationBtnNew('new')">申请</el-button>
      </el-form-item>
    </el-form>
    <el-tabs v-model="activeName" @tab-click="query" class="approvalMine">
        <el-tab-pane label="我的申请" name="queryMine"></el-tab-pane>
        <el-tab-pane label="待我审批" name="queryMyAudit">
          <div slot="label">
            待我审批
                <el-badge :value='workNumber' style="margin-bottom:20px"></el-badge>
          </div>
        </el-tab-pane>
        <el-tab-pane label="已审批" name="queryApproval"></el-tab-pane>
    </el-tabs>
    <table-list
    :loading="loading"
    :data="tableData"
    :page="page"
    :page-size="pageSize"
    :total="totalCount"
    :columnDefs="columnDefs"
    :tableRowClassName="tableRowClassName"
    @pageChange="pageChange">
      <template #applyReason={row}>
        <div class="applyReason">
          {{ row.applyReason }}
        </div>
      </template>
      <template #operate={row}>
        <el-button type="text" size="small" v-if="row.status === 1 && activeName == 'queryMine'" @click="exportDetails(row.id)">导出审批单</el-button>
         <!--1. 我的申请 审核不通过 已拒绝  2. 新增提交暂存 -->
         <el-button type="text" size="small"
          v-if="row.status === 2 && activeName == 'queryMine' || row.status === 10 && activeName == 'queryMine'" @click="update('new', row.id)">修改</el-button>
        <!--1. 我的申请 待审核 -->
          <el-button type="text" size="small" @click="approval(row.id)" v-if="row.status === 0 && activeName == 'queryMine'">催批</el-button>
        <el-button @click="applicationBtn('see', row.id)" type="text" size="small">查看详情</el-button>
      </template>
    </table-list>
    <application ref="application" @addSuccess="query"/>
    <download ref="Download"/>
  </div>
</template>

<script>
import TableList from '@/components/TableList.vue'
import Application from './application.vue'
import Download from './download.vue'
import { queryMine, queryMyAudit, update, listApplyAudited, sendSmsAuditPersonAgain } from '@/api/compApplyStamp.js'
import { ApprovalStatus } from '@/utils/constants'

export default {
  data () {
    return {
      loading: false,
      tableData: [],
      page: 1,
      pageSize: 10,
      totalCount: 0,
      workNumber: 0,
      eventId: '',
      applyReason: '',
      columnDefs: [
        { label: '编号', prop: 'eventId' },
        { label: '用章类型', prop: 'stampType' },
        { label: '用章原因', prop: 'applyReason', width: 200, showOverflowTooltip: false },
        { label: '申请人', prop: 'applyUser', width: 100 },
        {
          label: '审核人',
          formatter: (row) => {
            return row.auditPerson || row.preAuditPerson
          }, 
          width: 100
        },
        {
          label: '审核状态',
          formatter: (row) => {
            let status = ApprovalStatus.find(item => item.value === row.status)
            return status?.label || ''
          }
        },
        { label: '申请时间', prop: 'createTime' },
        // { label: '申请原因', prop: 'applyReason' },
        { label: '操作', prop: 'operate' }
      ],
      type: '',
      typeList: ApprovalStatus,
      activeName: 'queryMine'
    }
  },
  components: {
    TableList,
    Application, 
    Download
  },
  methods: {
    tableRowClassName({ row, column, rowIndex, columnIndex }) {
      if (row.exportFlag && this.activeName === 'queryMine') {
          return 'export-row';
      }
        return '';
    },
    query () {
      this.page = 1
      this.getData()
    },
    pageChange (page) {
      this.page = page
      this.getData()
    },
    getData () {
      this.loading = true 
      let query = this.activeName === 'queryMyAudit' ? queryMyAudit : this.activeName === 'queryMine' ? queryMine : listApplyAudited
      query({
        pageNum: this.page,
        pageSize: this.pageSize,
        status: this.type,
        eventId: this.eventId,
        applyReason: this.applyReason
      }).then(res => {
        const { code, result } = res
        this.loading = false
        if (code !== 0) return
        this.tableData = result.records
        this.totalCount = result.total
        this.getNum()
      })
    },
    getNum() {
      queryMyAudit({
        pageNum: this.page,
        pageSize: this.pageSize,
      }).then(res => {
        const { code, result } = res
        this.loading = false
        if (code !== 0) return
        this.workNumber = result.total
      })
    },
    applicationBtn (type = 'new', id = null) {
      this.$refs.application.showDialog(type, id, this.activeName)
    },
    applicationBtnNew (type = 'new', id = null) {
      this.$refs.application.showDialog(type, id, 'queryMine')
      // this.$dialog(
      //   demo,
      //   {
      //     id: '123',
      //     funcs: (res) => {
      //       console.log('返回的数据', res)
      //     },
      //     on: {
      //       ok() {
      //         console.log('ok 回调')
      //       },
      //       cancel() {
      //         console.log('cancel 回调')
      //       },
      //       close() {
      //         console.log('modal close 回调')
      //       },
      //     },
      //   },
      //   {
      //     title: '自定义标题',
      //     width: '40%',
      //     footer: true,
      //   }
      // )
    },
    update (type = 'new', id = null) {
      this.$refs.application.showDialog(type, id, 'queryMine')
    },
    async exportDetails (id) {
      await update({ exportFlag: true, id: id })
      await this.getData()
      this.$refs.Download.getDetails(id)
    },
    async approval(id = '') {
      this.$confirm('此操作将进行催批, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let params = {
          'id': id
        }
        let res = await sendSmsAuditPersonAgain(params)
        if (res.code === 0) {
          this.$message({ type: 'success', message: '催批成功!' })
        }
        await this.getData()
      })
    },
  },
  mounted () {
    this.query()
  }
}
</script>
<style>
.export-row{
  /* background-color: #bddfff !important; */
}
.applyReason {
  word-break: break-all;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
   max-height: 90px;
  overflow-y: hidden;
  width: 200px;
  padding-right: 15px;
}
</style>
